import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation, useQueryClient } from "react-query";
import { ParametroCobrancaRequest } from "../typings";

function useSaveParametroCobranca(tenant?: string) {
  const queryClient = useQueryClient();
  const url = `v1/parametros-cobranca/${tenant}`;

  return useMutation(
    url,
    async (parametros: ParametroCobrancaRequest) => {
      const { data } = await http.put<{ id: string }>(url, parametros);
      return data;
    },
    {
      onError: (e) => showErrorAxios(e),
      onSuccess: () => queryClient.invalidateQueries(url),
    }
  );
}

export default useSaveParametroCobranca;
